import Slider from 'react-slick';

export const sliderGoTo = (ref: React.MutableRefObject<Slider>) => (nextSlide) => () => {
  ref.current.slickGoTo(nextSlide);
};
